import { Group, Modal, Stack, TextInput } from "@mantine/core"
import { showNotification } from "@mantine/notifications"
import { Button } from "@tfg/ui"
import { Dispatch, SetStateAction, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  CreateSupplierMappingRequestDto,
  UpdateSupplierMappingRequestDto,
} from "~/gen/api/types"
import { SUPPLIER_INITIAL_VALUES } from "~/pages/Brand/OrganizationSettings/Suppliers"
import { useCreateSupplierMappingByEmailMutation } from "~/pages/Brand/OrganizationSettings/Suppliers/hooks/useCreateSupplierMappingByEmailMutation"

type Props = {
  opened: boolean
  onClose: () => void
  openDrawer: () => void
  setInitialValues: Dispatch<
    SetStateAction<
      CreateSupplierMappingRequestDto | UpdateSupplierMappingRequestDto
    >
  >
  searchSupplier: string
}

export function SupplierCreationModal({
  opened,
  onClose,
  openDrawer,
  setInitialValues,
  searchSupplier,
}: Props) {
  const [email, setEmail] = useState("")
  const { t } = useTranslation("organizationSettings")

  const { mutateAsync: createSupplierMappingByEmail } =
    useCreateSupplierMappingByEmailMutation({
      searchSupplier,
    })

  const handleCreateSupplierMappingByEmail = async () => {
    const { data } = await createSupplierMappingByEmail({ email })
    if (data) {
      showNotification({
        title: "Supplier created",
        message: `Supplier created successfully`,
        color: "teal",
      })
      setEmail("")
      onClose()
    } else {
      setInitialValues((prev) => ({
        ...prev,
        ...SUPPLIER_INITIAL_VALUES,
        email,
      }))
      setEmail("")
      onClose()
      openDrawer()
    }
  }

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("supplierSettings.addNewSupplier")}
      centered
    >
      <Stack align="center">
        <Group>
          <TextInput
            value={email}
            onChange={(event) => setEmail(event.currentTarget.value)}
            placeholder={t("supplierSettings.supplierEmail")}
            w={250}
          />
          <Button onClick={handleCreateSupplierMappingByEmail}>
            {t("supplierSettings.submit")}
          </Button>
        </Group>
      </Stack>
    </Modal>
  )
}
